export const TABS = {
  COMMENTS: "comments",
  LIVESTREAM_CHAT: "livestreamChat",
};
